import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './components/Login.vue';
import Dashboard from './views/Dashboard.vue';
import InvoiceTable from './components/InvoiceTable.vue';
import ProblemsTable from './components/ProblemsTable.vue';
import ImportedFilesTable from './components/ImportedFilesTable.vue';
import DeliveryNotesQr from './components/DeliveryNotesQr.vue';
import { RewistaTobaccoToken } from '@/customTypes';
import JwtDecode from 'jwt-decode';
import { RewistaTobaccoService } from '@/services/rewistaTobaccoService';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Dashboard,
      beforeEnter: async (to, from, next) => {
        if (Vue.$cookies.isKey('authToken')) {
          const accessToken = Vue.$cookies.get('authToken');
          const decodedAccessToken = JwtDecode<RewistaTobaccoToken>(accessToken);
          const expirationDate = new Date(0);
          expirationDate.setUTCSeconds(decodedAccessToken.exp);
          if (expirationDate > new Date()) {
            next();
            return;
          }
        }
        if (Vue.$cookies.isKey('refreshToken')) {
          const refreshToken = Vue.$cookies.get('refreshToken');
          const decodedRefreshToken = JwtDecode<RewistaTobaccoToken>(refreshToken);
          const expirationDate = new Date(0);
          expirationDate.setUTCSeconds(decodedRefreshToken.exp);
          if (new Date() > expirationDate) {
            next({ name: 'login' });
            return;
          } else {
            const response = await new RewistaTobaccoService().axiosRefreshRequest(refreshToken);
            if (response.status === 200) {
              Vue.$cookies.set('authToken', response.data);
              next();
              return;
            } else {
              next({ name: 'login' });
              return;
            }
          }
        } else {
          next({ name: 'login' });
          return;
        }
      },
      children: [
        {
          path: '',
          name: 'Dashboard',
          component: ProblemsTable,
        },
        {
          path: 'DeliveryNotesQr',
          component: DeliveryNotesQr,
        },

      ],

    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },

  ],
});
